import { ServiceInsuranceMapper } from '../ServiceInsurance/ServiceInsuranceMapper.js';

class ServiceUpsalesMapper {
  static convertToAvailableUpsale(data) {
    return {
      available: data
    };
  }
  static createFromResponse(_ref) {
    let {
      has_adult_signature,
      has_additional_handling,
      insurance,
      has_print_in_store,
      has_proof_of_delivery
    } = _ref;
    return {
      adultSignature: ServiceUpsalesMapper.convertToAvailableUpsale(has_adult_signature),
      additionalHandling: ServiceUpsalesMapper.convertToAvailableUpsale(has_additional_handling),
      insurance: ServiceInsuranceMapper.createFromResponse(insurance),
      printInStore: ServiceUpsalesMapper.convertToAvailableUpsale(has_print_in_store),
      proofOfDelivery: ServiceUpsalesMapper.convertToAvailableUpsale(has_proof_of_delivery)
    };
  }
}

export { ServiceUpsalesMapper };
//# sourceMappingURL=ServiceUpsalesMapper.js.map
